import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { SignoutComponent } from './signout/signout.component';
import { SigninComponent } from './signin/signin.component';
import { LoginComponent } from './login/login.component';
import { MaterialDesignModule } from 'global-shared/modules/material-design.module';


@NgModule({
  declarations: [
    LoginComponent,
    SigninComponent,
    SignoutComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MaterialDesignModule,
  ]
})
export class AuthModule { }
